"use client"

import { DiscAlbum } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DiscAlbumIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DiscAlbumIcon = component(Icon)({ as: DiscAlbum })
